import React from 'react';
import { useTranslation } from "react-i18next";
import { useUtils } from "../hooks/useUtils";
import { HeadingBuilder } from "../components/HeadingBuilder";
//import React, { useContext } from 'react';
//import { ShopperContext } from '../context/shopper';

export const TripHeader = ( {trip} ) => {
  const { t } = useTranslation();
  const { getTripDateTimeLabel } = useUtils();

  const circleNotCurrentMessage =
    trip.circle.is_current ? '' : t('circle.circleNotCurrent.tippyContent');

  return (
    <>
      <b>{t('trip.formPart.shoppingTripPrompt')}</b>
      {/* Shopping Trip: */}
        &nbsp;{ getTripDateTimeLabel({trip})}
        {/* The '&nbsp;' here insures space between Prompt and DateTimeLabel.
        Is the space char at end of 'shoppingTripPrompt' not enough? */}
      <br />
      <HeadingBuilder
        tippyAlertText = {t('trip.circlePrompt.tippyContent')}
        tippyText      = {t('trip.circlePrompt.tippyContent')}
        tippyInfoText  = {circleNotCurrentMessage}
        linkUrl        = {`/circles/${trip.circle.id}`}
        headingText    = {t('trip.circlePrompt.label')}
        value          = {trip.circle.identifier}
                       // Circle: am_circle
      />
    </>
  )
}

export default TripHeader